import { SelectOptionType } from '@octano/global-ui';
import { useSurveyLoader } from '../../SurveyCreate/parts/SurveyCreateLoader';
import FormContainer, { FormValues } from '../../SurveyCreate/parts';
import DisplayError from '../../../../../../components/info/DisplayError';
import SurveyPublishedEditLoader from './SurveyPublishedEditLoader';
import { SurveyStatus } from '../../../types/Survey';
import { SectionKind } from '../../../types/types';

export default function SurveyPublishedEdit() {
  const { data } = useSurveyLoader();

  return (
    <SurveyPublishedEditLoader>
      {({ survey, refresh }) => {
        if (!survey || !data) {
          return (
            <DisplayError
              insideCard
              textBody="No se cargaron los datos"
              retryAction={refresh}
            />
          );
        }

        const contextOptions: SelectOptionType[] = data.surveyContexts.map(
          (c) => ({ label: c.name, value: c.id }),
        );
        const periodOptions: SelectOptionType[] = data.periods.map((p) => ({
          label: p.name,
          value: p.id,
          startDate: p.startDate,
          endDate: p.endDate,
        }));
        const scaleOptions: SelectOptionType[] = data.scales.map((s) => ({
          label: s.title,
          value: s.id,
        }));

        const closedSections = (survey.sections ?? []).filter(
          (s) => (s.kind ?? SectionKind.Closed) === SectionKind.Closed,
        );
        // La escala es única por encuesta, pero solo la llevan las preguntas
        // cerradas: hay que buscarla en la primera sección CERRADA, no en la [0].
        const scaleId = closedSections[0]?.questions?.[0]?.evaluationScale?.id;

        const defaultValues: Partial<FormValues> = {
          id: survey.id,
          title: survey.title,
          context:
            contextOptions.find((opt) => opt.value === survey.context) ?? null,
          period:
            periodOptions.find((opt) =>
              survey?.surveyPeriod?.some((sp) => sp?.period?.id === opt.value),
            ) ?? null,
          startDate: survey.startDate,
          endDate: survey.endDate,
          scale: scaleOptions.find((opt) => opt.value === scaleId) ?? null,
          sections: survey.sections.map((section) => ({
            id: section.id,
            title: section.name,
            description: section.description ?? '',
            kind: section.kind ?? SectionKind.Closed,
            questions: section.questions.map((q) => ({
              id: q.id,
              text: q.text,
            })),
          })),
        };

        const isFinished = survey.status === SurveyStatus.Finished;

        return (
          <FormContainer
            defaultValues={defaultValues}
            isPublished={true}
            isFinished={isFinished}
          />
        );
      }}
    </SurveyPublishedEditLoader>
  );
}
